import React, { useState } from 'react';
import { heroImageBackgroundPosition, normalizeHeroImageFocal } from '../heroImageFocal';

/**
 * Home editorial hero — full-bleed photo with cream left scrim
 * (same composition as /custom-jewelry premium hero).
 */
export default function HomeEditorialHero({ slide, copyPanel, className = '', onImageReady }) {
  const [ready, setReady] = useState(false);
  const hasImage = Boolean(slide?.src);
  const focal = normalizeHeroImageFocal({ x: slide?.focal_x, y: slide?.focal_y });
  const pos = heroImageBackgroundPosition(focal);

  const markReady = () => {
    setReady(true);
    onImageReady?.(true);
  };

  return (
    <section
      className={`home-hero home-hero--editorial home-hero--editorial-split${hasImage ? ' home-hero--editorial-has-media' : ''}${ready ? ' home-hero--ready' : ''}${className ? ` ${className}` : ''}`.trim()}
      aria-label="Welcome"
    >
      {hasImage ? (
        <div className="home-hero__showcase" aria-hidden="true">
          <div className="home-hero__showcase-media">
            <img
              key={slide.src}
              className="home-hero__showcase-img"
              src={slide.src}
              alt={slide.alt || ''}
              style={{ objectPosition: pos }}
              loading="eager"
              decoding="async"
              fetchPriority="high"
              onLoad={markReady}
              onError={markReady}
            />
            <div className="home-hero__showcase-grade" aria-hidden="true" />
            <div className="home-hero__showcase-glow" aria-hidden="true" />
            <div className="home-hero__showcase-vignette" aria-hidden="true" />
          </div>
          <div className="home-hero__showcase-scrim" aria-hidden="true" />
        </div>
      ) : (
        <div className="home-hero__showcase home-hero__showcase--placeholder" aria-hidden="true" />
      )}

      <div className="home-hero__editorial-inner">
        <div className="home-hero__editorial-copy-wrap">{copyPanel}</div>
      </div>
    </section>
  );
}
